import Guides from './Guides.vue'

export default Guides
